import { IonButton } from '@ionic/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useUser from '../../contexts/hooks/useUser'
import { ModalContext } from '../../contexts/ModalContext'
import { trpc } from '../../modules/trpc'
import UserPreferenceQuestions from '../questionParts/UserPreferenceQuestions'
import { UserPreferenceSlideStateType } from '../types/types'

interface Props {
	state: [
		UserPreferenceSlideStateType,
		React.Dispatch<React.SetStateAction<UserPreferenceSlideStateType>>,
	]
}

const UserPreferenceSlide: React.FC<Props> = ({ state }) => {
	const { mutate: updateUser } = trpc.user.update.useMutation({})

	const { closeModal } = useContext(ModalContext)

	const { user, setUser } = useUser()
	const { t } = useTranslation('pages_onboarding')
	const history = useHistory()

	const submit = () => {
		if (!user) return console.error('No user')

		const fieldsToEdit = {
			preference: state[0]?.preference ?? null,
			interestedInTech: state[0]?.interestedInTech ?? false,
		}

		try {
			updateUser({ id: user.id, fieldsToEdit })

			setUser({
				...fieldsToEdit,
			})
			closeModal()
			history.replace('/')
		} catch (error) {
			console.error('Failed to update user preferences', error)
		}
	}

	const isButtonDisabled =
		!state[0] || state[0].preference === undefined || state[0].interestedInTech === undefined

	return (
		<>
			<h1 className='text-text-dark dark:text-white'>{t('userPreferenceSlide.melkeinValmis')}</h1>
			<UserPreferenceQuestions options={state[0]} setOptions={state[1]} />
			<IonButton
				expand='block'
				disabled={isButtonDisabled}
				onClick={submit}
				className='mt-6 w-full font-semibold'
				style={
					{
						'--background': '#3cb49f',
						'--background-activated': '#2d9b88',
						'--background-disabled': '#4a5568',
						'--color': '#ffffff',
						'--color-disabled': '#718096',
						'--border-radius': '16px',
						'--padding-top': '14px',
						'--padding-bottom': '14px',
						'--box-shadow': '0 4px 20px rgba(60, 180, 159, 0.35)',
					} as React.CSSProperties
				}
			>
				{t('userPreferenceSlide.valmis')}
			</IonButton>
		</>
	)
}

export default UserPreferenceSlide
